export const CLOSE_MODAL_HOTKEYS = 'Esc';
export const DELETE_SELECTED_INVOICELINES = 'Delete';
export const APPLY_OCR_TRAINING = 'Ctrl+Alt+T';
export const DELETE_OCR_TRAINING = 'Ctrl+Alt+W';
export const OCR_TRAINING_SQL = "Ctrl+Alt+'";
export const PARK_DOCUMENT = 'Ctrl+Alt+P';
export const LINK_RECEIPT = 'F8';
export const BACK_TO_GROUP = 'Ctrl+Alt+G';
export const SHOW_HISTORY = 'Ctrl+Alt+H';
export const SAVE_FILE = 'Ctrl+Alt+S';
export const CLOSE_TOGGLELIST = 'Esc';
export const ARROW_DOWN = 'ArrowDown';
export const ARROW_UP = 'ArrowUp';
export const SPACE = 'Space';

// File handler hotkeys
export const FILE_HANDLER_NAVIGATE_LEFT_HOTKEY = 'ArrowLeft';
export const FILE_HANDLER_NAVIGATE_RIGHT_HOTKEY = 'ArrowRight';
export const FILE_HANDLER_NAVIGATE_UP_HOTKEY = 'ArrowUp';
export const FILE_HANDLER_NAVIGATE_DOWN_HOTKEY = 'ArrowDown';
export const FILE_HANDLER_SEND_TO_ADMINISTRATION_HOTKEY = 'Enter';
export const FILE_HANDLER_SPLIT_DOCUMENT_HOTKEY = 'Space';
export const FILE_HANDLER_DELETE_PAGE_HOTKEY = 'Delete';
export const FILE_HANDLER_DELETE_DOCUMENT_HOTKEY = 'Backspace';
export const FILE_HANDLER_ROTATE_PAGE_HOTKEY = 'R';
export const FILE_HANDLER_ROTATE_DOCUMENT_HOTKEY = 'Shift+R';
